<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div mat-dialog-title>
  Assignment : {{ data.data[0].TOPIC_NAME }}
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content id="modalAssignment" class="mat-typography" style="padding: 0px 3%;">
  <div class="container">
    <div class="row justify-content-center mb-4" style="min-height: 200px;">
      <div class="col-md-6 col-12 text-center">
        <div class="height-center">
          <p>ดาวน์โหลด Assignment</p>
          <p>{{ data.data[0].ASSIGNMENT_FILE_NAME }}</p>
          <lifedi-btn lable="ดาวน์โหลด" (click)="downloadFile(data.data[0].ASSIGNMENT_FILE)"
            customStyle="background-color: #414A6B; color: #FFF; margin: 0px; padding: 0 30px;">
          </lifedi-btn>
        </div>
      </div>
      <hr class="vertical d-none d-md-block d-lg-block d-xl-block">
      <hr class="horizon d-none d-block d-sm-block d-md-none">
      <div *ngIf="!data.data[0].SENDED" class="col-md-6 col-12 text-center">
        <div class="height-center">
          <p>ส่ง Assignment</p>
          <form [formGroup]="assignForm">
            <nz-upload
              nzAccept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              [nzShowUploadList]="{ showRemoveIcon: true ,showDownloadIcon: false }" [nzCustomRequest]="successRequest"
              [nzFileList]="fileList" (nzChange)="handleChange($event, assignForm)">
              <button nz-button style="width: 70%;">Select File</button>
            </nz-upload>
            <div class="row mt-3">
              <small class="col-12 text-danger">สามารถส่ง Assignment ได้ 1 ครั้ง โปรดเช็คความถูกต้อง</small>
            </div>
            <lifedi-btn *ngIf="assignForm.valid && fileList.length > 0" class="mt-3" lable="อัปโหลด"
              customStyle="background-color: #3E8C1A; color: #FFF; margin: 0px; padding: 0 30px; margin-top: 10px"
              style="margin-top: 15px" (click)="uploadFile()">
            </lifedi-btn>
            <lifedi-btn *ngIf="!assignForm.valid || fileList.length === 0" class="mt-3" lable="อัปโหลด" disabled="true"
              customStyle="padding: 0 30px; color:#FFFFFF; margin-top: 15px">
            </lifedi-btn>
          </form>
        </div>
      </div>
      <div *ngIf="data.data[0].SENDED" class="col-md-6 col-12 text-center">
        <div class="height-center">
          <p>คุณได้ส่งไฟล์เอกสารแล้ว</p>
        </div>
      </div>
    </div>
    <div *ngIf="data.data[0].FEEDBACK.length > 0" class="row mb-4">
      <div class="col-12">
        <h3 style="color: #A90088;">Feedback จากผู้สอน</h3>
        <mat-card style="border: 1px solid;">
          <a [href]="data.data[0].FEEDBACK[0].FEEDBACK_DOC" target="_blank" style="text-decoration: underline;">
            {{ data.data[0].FEEDBACK[0].FEEDBACK_DOC_ORIGINAL }}
          </a>
          <small style="display: inline; float: right;">{{ data.data[0].FEEDBACK[0].FEEDBACK_DATE | dateTime }}</small>
          <p class="mt-2">{{ data.data[0].FEEDBACK[0].FEEDBACK_MESSAGE }}</p>
        </mat-card>
      </div>
    </div>
  </div>
</mat-dialog-content>
